import React, { useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { styled } from "@mui/material/styles";
import TablePagination from "@mui/material/TablePagination";
import { useTranslation } from "react-i18next";
import useModuleSummary, { STATUS_LABELS } from "./useModuleSummary";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableRow: {
    backgroundColor: "#1F4A7C",
    color: "#fff",
  },
  tableCell: {
    backgroundColor: "#f2f2f2",
    padding: "10px",
    fontWeight: "bold",
    border: "1px solid #ddd",
  },
  blueText: {
    color: "#1F4A7C",
  },
});

// const headerData = [
//   { slno: "Sl. No" },
//   { moduleName: "Module Name" },
//   { draftFile: "Draft File" },
//   { approvedFile: "Approved File" },
//   { totalFile: "Total File" },
// ];

const getStickyStyle = (key, isHeader = false, isOddRow = false) => {
  const bodyBackground = isOddRow ? "#f1f0f5" : "#ffffff"; // Match your row colors

  switch (key) {
    case "developmentAuthorityName":
      return {
        position: "sticky",
        left: 0,
        zIndex: isHeader ? 4 : 2,
        background: isHeader ? "#1f4a7c" : bodyBackground,
      };

    case "grandTotal":
      return {
        position: "sticky",
        right: 0,
        zIndex: isHeader ? 4 : 2,
        background: isHeader ? "#1f4a7c" : bodyBackground,
        fontWeight: "bold",
      };

    default:
      return {};
  }
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 13,
    fontWeight: "bold",

    width: "110px",
    minWidth: "110px",
    maxWidth: "110px",

    whiteSpace: "normal", // Allow wrapping
    wordBreak: "break-word", // Break long words
    overflowWrap: "break-word",
    textAlign: "center",
    padding: "9px !important",
    lineHeight: "18px",
  },

  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    width: "110px",
    minWidth: "110px",
    maxWidth: "110px",

    whiteSpace: "normal",
    wordBreak: "break-word",
    textAlign: "center",
    padding: "9px !important",
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const InboxTable = ({ apiData, location1, newApiData }) => {
  const moduleSummary = useModuleSummary(apiData);

  const { t } = useTranslation();
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React.useState(0);

  const tableData = newApiData?.tableData || [];
  const statuses = (newApiData?.statuses || []).filter((status) => status && status !== "null");
  const moduleNames = newApiData?.moduleNames || [];

  const headerData = useMemo(() => {
    return [
      {
        key: "serialNo",
        label: "Sl. No",
      },
      {
        key: "developmentAuthorityName",
        label: "Development Authority",
      },

      ...statuses.map((status) => ({
        key: status,
        label: STATUS_LABELS[status] || status,
      })),

      {
        key: "grandTotal",
        label: "Grand Total",
      },
    ];
  }, [statuses]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <Paper sx={{ overflow: "hidden", marginY: 2 }}>
      <TableContainer>
        <Table
          className={classes.table}
          aria-label="simple table"
          style={{
            overflowX: "auto",
            maxWidth: "100%",
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell
                colSpan={headerData.length}
                align="center"
                style={{
                  backgroundColor: "#1F4A7C",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: 18,
                }}
              >
                {location1 || "All Department Authorities"}
              </TableCell>
            </TableRow>
          </TableHead>
          {/* <TableHead>
            <TableRow className={classes.tableRow}>
              {headerData.map((item) => (
                <TableCell key={Object.values(item)[0]}>{Object.values(item)[0]}</TableCell>
              ))}
            </TableRow>
          </TableHead> */}
          <TableHead>
            <TableRow className={classes.tableRow}>
              {headerData.map((item) => (
                <StyledTableCell key={item.key} style={getStickyStyle(item.key, true)}>
                  {item.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          {/* <TableBody style={{ backgroundColor: "#fbfaff" }}>
            {moduleSummary?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
              <StyledTableRow key={row.moduleName}>
                <StyledTableCell>{index + 1 + page * rowsPerPage}</StyledTableCell>

                <StyledTableCell>{t(row.moduleName) || "N/A"}</StyledTableCell>

                <StyledTableCell>{row.draft}</StyledTableCell>

                <StyledTableCell>{row.approved}</StyledTableCell>

                <StyledTableCell>{row.total}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody> */}
          <TableBody style={{ backgroundColor: "#fbfaff" }}>
            {tableData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
              <StyledTableRow key={row.developmentAuthorityName}>
                {headerData.map((column) => (
                  <StyledTableCell
                    key={column.key}
                    style={{
                      ...getStickyStyle(column.key, false, index % 2 === 0),
                      fontWeight: column.key === "grandTotal" ? "bold" : "normal",
                    }}
                  >
                    {column.key === "serialNo" ? page * rowsPerPage + index + 1 : row[column.key] || 0}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 75, 100]}
        component="div"
        count={tableData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default InboxTable;
